// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Submits } = initSchema(schema);

export {
  Submits
};